<template>
  <v-container fill-height>
    <v-row class="fill-height" justify="center" no-gutters>
      <v-col cols="12" sm="8" md="5" lg="4" xl="3">
        <df-messenger
          location="us-central1"
          project-id="balcao-virtual-default"
          :agent-id="_agentID"
          language-code="pt-br"
          max-query-length="-1"
        >
          <v-btn
            class="text-none text-body-2 font-weight-bold mt-2"
            color="red"
            outlined
            elevation="1"
            absolute
            top
            right
            small
            style="z-index: 9999"
            @click="handleFinalize"
          >
            <v-icon small class="mr-1">mdi-phone-remove</v-icon> Finalizar
          </v-btn>

          <df-messenger-chat
            :chat-icon="require('@/assets/mini_logo.png')"
            chat-title="SEDUC Ribeirão Preto"
            placeholder-text="Digite sua mensagem aqui"
            :bot-actor-image="require('@/assets/mini_logo.png')"
            :chat-title-icon="require('@/assets/mini_logo.png')"
          >
          </df-messenger-chat>
        </df-messenger>
      </v-col>
    </v-row>

    <!-- Confirmação de finalização -->
    <v-dialog v-model="finalizeDialog" max-width="400">
      <v-card>
        <v-card-title>Confirmar Finalização</v-card-title>
        <v-card-text
          >Tem certeza que deseja finalizar o atendimento?</v-card-text
        >
        <v-card-actions>
          <v-spacer />
          <v-btn class="text-none" plain @click="finalizeDialog = false">
            Cancelar
          </v-btn>
          <v-btn class="text-none" color="primary" @click="finalize">
            Finalizar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <SelectorDialog
      v-model="payloadModal"
      :loading="loading"
      :cities="cities"
      @submit="dialogSubmit"
    />
  </v-container>
</template>

<script>
import { handleFinishAttendance, handleAlert } from "@/utils";
import { mapActions, mapState } from "vuex";
import { updateAttendance } from "@/services/attendance";
import SelectorDialog from "@/components/selectorDialog/SelectorDialog";

export default {
  name: "ChatCx",

  components: {
    SelectorDialog,
  },

  data() {
    return {
      loading: false,
      finalizeDialog: false,
      payloadModal: false,
      cities: [],
      parametersCX: {},
      sessionId: null,
      payloadMenssagem: "",
      readMode: false,
      dfResponseHandler: null,
      preSelectionInProgress: false,
    };
  },

  computed: {
    ...mapState("socket", [
      "attendance",
      "messages",
      "inQueue",
      "shouldClearStorage",
      "appointment",
    ]),
    ...mapState(["preSelection"]),
    _agentID() {
      return process.env.VUE_APP_AGENT_DF;
    },

    _hasFullPreSelection() {
      return !!(
        this.preSelection?.deskID &&
        this.preSelection?.subgroupID &&
        this.preSelection?.groupID
      );
    },

    /**
     * Campos que o bot precisa ter coletado para o link direto seguir para a
     * fila sem depender do payload de hierarquia (cities/comarcas) do bot.
     * VUE_APP_DIRECT_LINK_IDENTIFICATION_FIELDS: lista separada por vírgula
     * (name, cpf, email, phone). Padrão "name,cpf". "off" desliga o fallback.
     */
    _directLinkIdentificationFields() {
      const raw = (
        process.env.VUE_APP_DIRECT_LINK_IDENTIFICATION_FIELDS || "name,cpf"
      )
        .trim()
        .toLowerCase();

      if (raw === "off" || raw === "false") return [];

      return raw
        .split(",")
        .map((field) => field.trim())
        .filter(Boolean);
    },
  },

  watch: {
    inQueue(newValue) {
      if (newValue) {
        const isAppointmentQueue =
          this.appointment && this.appointment.autoScheduled === true;

        if (isAppointmentQueue && !this.appointment._id) {
          console.warn("Appointment ID not available in ChatCx");
          return;
        }

        const queuePath = isAppointmentQueue
          ? `/queue-appointments/${this.appointment._id}`
          : "/queue";

        if (this.$route.path !== queuePath) {
          this.$router.push({ path: queuePath });
        }
      }
    },
    shouldClearStorage(newValue) {
      if (newValue) {
        const dfMessenger = document.querySelector("df-messenger");
        if (dfMessenger && typeof dfMessenger.clearStorage === "function") {
          dfMessenger.clearStorage();
        }
        this.setShouldClearStorage(false);
      }
    },
  },

  created() {
    if (!this.attendance) {
      this.$router.push({ path: "/home" });
    }
  },

  mounted() {
    if (this.shouldClearStorage || this.preSelection.groupID) {
      this.setupDfMessenger();
    }
    this.setupPayloadListener();
  },

  beforeDestroy() {
    if (this.dfResponseHandler) {
      window.removeEventListener(
        "df-response-received",
        this.dfResponseHandler
      );
      this.dfResponseHandler = null;
    }
  },

  methods: {
    ...mapActions("socket", [
      "requestAttendance",
      "cancelAttendance",
      "setAttendance",
      "setInQueue",
      "dialogAttendance",
      "setMessages",
      "setShouldClearStorage",
    ]),
    ...mapActions(["setRequester"]),

    handleFinalize() {
      this.finalizeDialog = true;
    },

    setupDfMessenger() {
      const dfMessenger = document.querySelector("df-messenger");
      if (dfMessenger) {
        if (this.shouldClearStorage || this.preSelection.groupID) {
          if (dfMessenger && typeof dfMessenger.clearStorage === "function") {
            dfMessenger.clearStorage();
          }
          this.setShouldClearStorage(false);
        }
        dfMessenger.addEventListener("df-messenger-loaded", () => {
          setTimeout(() => {
            try {
              dfMessenger.renderCustomText(
                "Olá! Boas-vindas ao Balcão Virtual da Secretaria Municipal da Educação de Ribeirão Preto. Como posso ajudar?"
              );
              dfMessenger.renderCustomText("Qual o seu nome completo?");
            } catch (error) {
              console.error("Erro ao enviar mensagem via API:", error);
            }
          }, 500);
        });
      } else {
        setTimeout(() => this.setupDfMessenger(), 1000);
      }
    },

    /** === Listener de payloads vindos do bot === */
    async setupPayloadListener() {
      if (this.dfResponseHandler) {
        window.removeEventListener(
          "df-response-received",
          this.dfResponseHandler
        );
      }

      this.dfResponseHandler = (event) => this.handleDfResponse(event);
      window.addEventListener("df-response-received", this.dfResponseHandler);
    },

    async handleDfResponse(event) {
      this.parametersCX = event?.detail?.raw?.queryResult?.parameters;
      if (this.parametersCX && this.parametersCX.session) {
        this.sessionId = this.parametersCX.session.split("/sessions/")[1];
      }
      if (this.parametersCX?.finish) {
        this.finalize();
        return;
      }
      try {
        const payload =
          event?.detail?.raw?.queryResult?.responseMessages?.[0]?.payload
            ?.custom;

        if (payload?.cities || payload?.comarcas) {
          if (payload?.cities) {
            this.cities = payload.cities.map((city) => ({
              name: city.name,
              _id: city.name,
            }));
          }

          if (this._hasFullPreSelection) {
            this.handlePreSelection();
            return;
          }

          this.payloadModal = true;
          return;
        }

        // Link direto (groupID + subgroupID + deskID já conhecidos): assim que
        // o bot terminar a identificação do cidadão, segue para a fila do
        // balcão sem esperar o payload de hierarquia, que agentes de outros
        // tenants podem não emitir.
        if (this._hasFullPreSelection && this.isIdentificationComplete()) {
          this.handlePreSelection();
        }
      } catch (error) {
        console.error("Erro ao processar resposta do Dialogflow:", error);
      }
    },

    /** Dados do solicitante coletados pelo bot (somente campos preenchidos). */
    getRequesterFromBot() {
      const params = this.parametersCX || {};
      const toText = (value) =>
        value === undefined || value === null ? "" : String(value).trim();

      const requester = {
        name: toText(params.person?.name || params.name),
        cpf: toText(params.cpf),
        email: toText(params.email),
        phone: toText(params.phone),
      };

      return Object.fromEntries(
        Object.entries(requester).filter(([, value]) => !!value)
      );
    },

    isIdentificationComplete() {
      const fields = this._directLinkIdentificationFields;
      if (!fields.length) return false;

      const requester = this.getRequesterFromBot();
      return fields.every((field) => !!requester[field]);
    },

    async dialogSubmit(event) {
      try {
        if (this.cities.length) {
          this.payloadMenssagem = event.city._id;
          this.enviarMensagemComEnter();
          return;
        }

        await this.handleCreateAttendance(event);
      } catch (err) {
        this.handleAlert("Erro ao processar seleção", "error");
      }
    },

    /** === Criação de atendimento === */
    async handleCreateAttendance(payload) {
      await this.setRequester({
        name: this.parametersCX?.person?.name || "",
        cpf: this.parametersCX?.cpf || "",
        email: this.parametersCX?.email || "",
        phone: this.parametersCX?.phone || "",
      });

      const response = await updateAttendance(this.attendance._id, {
        requester: {
          name: this.parametersCX?.person?.name,
          cpf: this.parametersCX?.cpf,
        },
        attendanceFormat: "chat",
        comarcaID: payload.groups._id,
        varaID: payload.subgroups._id,
        deskID: payload.desks._id,
      });

      this.setAttendance(response.data);

      await this.requestAttendance({
        data: {
          protocol: this.attendance.protocol,
          deskID: payload.desks._id,
        },
        callback: (error, data) => {
          if (error) throw error;
          this.setAttendance(data);
          this.readMode = true;
          this.setInQueue(true);
          this.setMessages([]);
          this.$router.push({ path: "/queue" }).catch(() => {});
        },
      });
    },

    /** === Envio de mensagem para o bot === */
    enviarMensagemComEnter() {
      const dfMessenger = document.querySelector("df-messenger");
      const shadowRoot = dfMessenger.shadowRoot;

      if (!shadowRoot) {
        return;
      }

      const slotElement = shadowRoot.querySelector("slot");
      if (!slotElement) {
        return;
      }

      const assignedElements = slotElement.assignedElements();
      if (!assignedElements || assignedElements.length === 0) {
        return;
      }

      const chatElement = assignedElements.find(
        (el) => el.tagName && el.tagName.toLowerCase() === "df-messenger-chat"
      );
      if (!chatElement) {
        return;
      }

      const chatShadowRoot = chatElement.shadowRoot;
      if (!chatShadowRoot) {
        return;
      }

      const userInput = chatShadowRoot.querySelector("df-messenger-user-input");
      if (!userInput) {
        return;
      }

      const userInputShadow = userInput.shadowRoot;
      if (!userInputShadow) {
        return;
      }

      const textarea = userInputShadow.querySelector("textarea.input-box");
      if (textarea) {
        textarea.value = this.payloadMenssagem;
        const event = new KeyboardEvent("keydown", {
          key: "Enter",
          code: "Enter",
          keyCode: 13,
          which: 13,
          bubbles: true,
          cancelable: true,
        });

        textarea.dispatchEvent(event);
      }
    },

    /** === Finalizar === */
    finalize() {
      this.handleFinishAttendance();
      this.finalizeDialog = false;
      this.setShouldClearStorage(true);
      this.$router.push({ path: "/home" }).catch(() => {});
    },

    /** === Pré-seleção automática === */
    async handlePreSelection() {
      // Evita pedidos duplicados: o bot pode emitir o payload de hierarquia e
      // também completar a identificação em respostas seguidas.
      if (this.preSelectionInProgress || !this.attendance?._id) return;
      this.preSelectionInProgress = true;

      try {
        const requester = this.getRequesterFromBot();

        await this.setRequester({
          name: "",
          cpf: "",
          email: "",
          phone: "",
          ...requester,
        });

        // Campos vazios são omitidos: a API (Joi.string) recusa "".
        const { name, cpf } = requester;
        const response = await updateAttendance(this.attendance._id, {
          ...((name || cpf) && {
            requester: {
              ...(name && { name }),
              ...(cpf && { cpf }),
            },
          }),
          // Mesmo formato do caminho manual (handleCreateAttendance) e do
          // atendimento rápido da Home: "video" fazia o socket gerar link de
          // reunião ao aceitar, indevido para o chat do link direto.
          attendanceFormat: "chat",
          comarcaID: this.preSelection.groupID,
          varaID: this.preSelection.subgroupID,
          deskID: this.preSelection.deskID,
        });

        this.setAttendance(response.data);

        await this.requestAttendance({
          data: {
            protocol: this.attendance.protocol,
            deskID: this.preSelection.deskID,
          },
          callback: (error, data) => {
            if (error) {
              this.preSelectionInProgress = false;
              this.handleAlert(
                error?.message ||
                  "Falha ao entrar na fila do balcão. Tente novamente.",
                "error"
              );
              return;
            }
            this.setAttendance(data);
            this.setInQueue(true);
            this.setMessages([]);
            this.$router.push({ path: "/queue" }).catch(() => {});
          },
        });
      } catch (err) {
        this.preSelectionInProgress = false;
        this.handleAlert("Erro ao criar atendimento automático", "error");
      }
    },

    handleFinishAttendance,
    handleAlert,
  },
};
</script>

<style src="./style.scss" lang="scss" scoped />
